import { all, spawn } from 'redux-saga/effects';
import * as movieSagas from 'sagas/movie';
import * as serieSagas from 'sagas/serie';

const rootSagas = [
  ...Object.values(movieSagas),
   ...Object.values(serieSagas),
];

export default function* rootSaga() {
  yield all([...rootSagas].filter(Boolean).map(spawn));
}
